import * as api from "../../../api";

export default {
  data() {
    return {
      options: [
      ],
      selected_: '',
      T:null,
      inited:false,
    }
  },
  computed: {
    class_: {
      get() {
        let tmp='works-filter__block works-filter__block-sale-type';
        if ( !this.is_show ) tmp+=' works-filter__block-advanced';
        return tmp;
      }
    },

    advanced: {
      get () {
        return (this.is_show || this.$store.getters.advanced);
      }
    },

    placeholder() {
      return this.$t('message.QuikSearch')
    },

    selected: {
      get () {
        let value = this.$store.getters.filters.region;
        if (value==null) value='';
        else value=this.selected_;
        return value;
      },
      set(val){
        this.selected_=val;
      },
    },
  },
  created(){
    this.initOptions();
  },
  methods     :{
    change_val(val){
      if(undefined !== val && null !== val && undefined !== val['value']) {

        if ( val['value']=='' && this.$store.getters.filters.region==null ) return;
        if ( val['value']==this.$store.getters.filters.region ) return;

        this.$store.dispatch ('setFilters', {'p':1, region: val.value}).then (() => {
          this.$store.dispatch ('setTags', {
            region: {
              value: val.label,
              key: val.value
            }
          })
        })
      }
    },

    initOptions() {
      this.$nextTick(function(){
        let value = this.$store.getters.filters.region;
        let url='/action/qsearch?type=region&raw';

        if(value!==undefined) {
          if (value.length > 0) {

            api.get(url, {ids: value}).then(response => {
              let val=response.data.regions[0].name;
              let sub_name=response.data.regions[0].sub_name;
              let id=response.data.regions[0].region_id;
              this.$store.dispatch('setTags', {
                  region: {
                    value: val,
                    key: id
                  }
                }
              );
              this.selected_ = {
                label: val,
                key: id,
                label_sub: sub_name,
              };
            }).catch(e => {
              console.log(e);
            })
          }
        }
      })
    },
  },

  updated: function () {
    this.$nextTick(function () {
      this.$emit('updated');
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/filter/FilterRegionMix.js
// module id = null
// module chunks = 